module.exports = __webpack_public_path__ + "img/chidimma.605f5ec2.jpg";